import React, {
  createContext,
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";
import { createPortal } from "react-dom";
import Popup from "./Popup";

export const PopupContext = createContext(null);

export const PopupProvider = ({ children }) => {
  const [popup, setPopup] = useState(null);
  const resolverRef = useRef(null);

  // Política de substituição: se já existe popup aberto, resolve o anterior
  // com valor "neutro" antes de mostrar o novo. Evita Promises pendentes.
  const replaceResolver = useCallback((newResolver, defaultForPrevious) => {
    if (resolverRef.current) {
      resolverRef.current(defaultForPrevious);
    }
    resolverRef.current = newResolver;
  }, []);

  const closeWith = useCallback((value) => {
    if (resolverRef.current) {
      resolverRef.current(value);
      resolverRef.current = null;
    }
    setPopup(null);
  }, []);

  const alert = useCallback(
    (config = {}) =>
      new Promise((resolve) => {
        replaceResolver(resolve, undefined);
        setPopup({ type: "alert", ...config });
      }),
    [replaceResolver]
  );

  const confirm = useCallback(
    (config = {}) =>
      new Promise((resolve) => {
        replaceResolver(resolve, false);
        setPopup({ type: "confirm", ...config });
      }),
    [replaceResolver]
  );

  const api = useMemo(() => ({ alert, confirm }), [alert, confirm]);

  return (
    <PopupContext.Provider value={api}>
      {children}
      {popup &&
        createPortal(
          <Popup
            type={popup.type}
            icon={popup.icon}
            title={popup.title}
            message={popup.message}
            confirmText={popup.confirmText}
            cancelText={popup.cancelText}
            onConfirm={() =>
              closeWith(popup.type === "confirm" ? true : undefined)
            }
            onCancel={() => closeWith(false)}
          />,
          document.body
        )}
    </PopupContext.Provider>
  );
};
